<script setup>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { onMounted, toRef, useId, useTemplateRef } from "vue";
import { useField } from "vee-validate";
const editor = useTemplateRef("editor");
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "",
  },
  value: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
});
const name = toRef(props, "name");
const inputId = useId();
const {
  errorMessage,
  handleChange,
  value: fieldValue,
} = useField(name, undefined);

const options = {
  modules: {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"], // toggled buttons
      ["link"],
      [{ list: "ordered" }, { list: "bullet" }],

      [{ color: [] }], // dropdown with defaults from theme

      ["clean"], // remove formatting button
    ],
  },
  theme: "snow",
  placeholder: props.placeholder,
};
onMounted(function () {
  const quill = new Quill(editor.value, options);
  quill.clipboard.addMatcher(Node.ELEMENT_NODE, function (node, delta) {
    delta.forEach((e) => {
      if (e.attributes) {
        e.attributes.background = "";
      }
    });
    return delta;
  });
  quill.on("text-change", function () {
    if (quill.root.innerText.trim() != "") {
      handleChange(quill.root.innerHTML);
    } else {
      handleChange("");
    }
  });
  if (fieldValue.value) {
    quill.root.innerHTML = fieldValue.value;
  }
});
</script>
<template>
  <label :for="inputId" v-if="label">{{ label }}</label>
  <div ref="editor" :id="inputId" style="height: 300px; overflow: scroll"></div>
  <span class="invalid-feedback" v-if="!!errorMessage">{{ errorMessage }}</span>
</template>

<style>
.ql-toolbar {
  background-color: #fff;
}
.ql-editor {
  background-color: #eee;
  font-family: "Raleway", sans-serif;
}
</style>
